import { defineComponent as _defineComponent } from 'vue'
import InlineIcon from '@/components/layout/shared/InlineIcon.vue';
import { SearchCategory } from '@/@types/enums/SearchCategory';
import githubIcon from '@/assets/img/integrations/github.svg';
import bitbucketIcon from '@/assets/img/integrations/bitbucket.svg';
import confluenceIcon from '@/assets/img/integrations/confluence.svg';
import gdocsIcon from '@/assets/img/integrations/gdocs.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchHistoryList',
  props: {
    searchHistory: null,
    isSearchHistoryLoading: { type: Boolean }
  },
  emits: ["onItemClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onItemClick', value: any): boolean;
}), expose: any, slots: any, attrs: any }) {

const SOURCE_ICONS: Record<string, string> = {
  GITHUB: githubIcon,
  BITBUCKET: bitbucketIcon,
  CONFLUENCE: confluenceIcon,
  GDRIVE: gdocsIcon,
};
const sourceIconUrl = (type: string | null): string | null => (type ? SOURCE_ICONS[type.toUpperCase()] ?? null : null);





const handleSelect = (item: any) => {
  const isSaveHistory = true;
  emit('onItemClick', { isSaveHistory, ...item });
};

return { __sfc: true,SOURCE_ICONS, sourceIconUrl, emit, handleSelect, InlineIcon, SearchCategory }
}

})